import { i18next } from '@yola/ws-sdk';

const getDefaultColorSchemeLabels = () => [
  ['ws-light-0', i18next.t('Light')],
  ['ws-light-1', i18next.t('Light-grey')],
  ['ws-dark-0', i18next.t('Dark')],
  ['ws-dark-1', i18next.t('Dark-grey')],
  ['ws-primary-0', i18next.t('Primary')],
  ['ws-secondary-0', i18next.t('Secondary')],
];

export default getDefaultColorSchemeLabels;
